
import React, { useContext, useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
  Modal,
  ModalBody,
  DropdownItem,
  Form,
  ModalHeader,
  ModalFooter,
  Row
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Col,
  PaginationComponent,
  Button,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent,
  RSelect,
  PreviewAltCard,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { userData, filterStatus } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { UserContext } from "../user-manage/UserContext";
import Api from "../../../Api";
import Swal from "sweetalert2";
import { GetTenantIdUp, formDataUsername, formatDates } from "../../../utils/Utils";
import { DateRangePicker } from 'react-date-range';
import Loaders from "../../components/loader/Loaders";

const ManageTenant = () => {
  const [tenantDataState, setTenant] = useState([]);

  const [statusState, setStatus] = useState(true);

  const [searchUserNameState, setSearchUserName] = useState('');
  const [loader, setLoader] = useState(false);

  const callGetTenant = async () => {
    setLoader(true);
    // const tenantData = await Api.GetTenant({IsActive: true, FirstName:""});
    const tenantData = await Api.GetTenant({ TenantId: GetTenantIdUp() });
    setTenant(tenantData?.filter(ele => ele?.isActive));
    setLoader(false);
  }

  const { contextData } = useContext(UserContext);

  const [data, setData] = contextData;
  //////////////////////////////////////

  const [sm, updateSm] = useState(false);
  const [onSearchText] = useState("");
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    ManageTenant: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    balance: "",
    phone: "",
    status: "Active",
  });

  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [modalForm, setModalForm] = useState(false);
  const [itemPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(1);
  const [showPicker, setShowPicker] = useState(false);
  const [historyTenant, setHistoryTenant] = useState({});
  const [historylist, setHistoryList] = useState([]);

  const handleInputClick = () => {
    setShowPicker(true);
  };

  const formattedDate = () => {
    if (selectedRange[0]) {
      const { startDate, endDate } = selectedRange[0];
      return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    }
    return '';
  };

  const handleDateRange = (ranges) => {
    setSelectedRange([ranges.selection]);
  };

  const handleCloseButtonClick = () => {
    setShowPicker(false);
  };

  // eslint-disable-line react-hooks/exhaustive-deps

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = userData.filter((item) => {
        return (
          item.name.toLowerCase().includes(onSearchText.toLowerCase()) ||
          item.email.toLowerCase().includes(onSearchText.toLowerCase())
        );
      });
      setData([...filteredObject]);
    } else {
      setData([...userData]);
    }
  }, [onSearchText, setData]);


  const toggleForm = () => setModalForm(!modalForm);

  // function to change the selected property of an item
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].checked = e.currentTarget.checked;
    setData([...newData]);
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      balance: "",
      phone: "",
      status: "Active",
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  // submit function to add a new item
  const onFormSubmit = (submitData) => {
    const { name, email, balance, phone } = submitData;
    let submittedData = {
      id: data.length + 1,
      avatarBg: "purple",
      name: name,
      role: "Customer",
      email: email,
      balance: balance,
      phone: phone,
      emailStatus: "success",
      kycStatus: "alert",
      lastLogin: "10 Feb 2020",
      status: formData.status,
      country: "Bangladesh",
    };
    setData([submittedData, ...data]);
    resetForm();
    setModal({ edit: false }, { add: false });
  };

  // submit function to update a new item
  const onEditSubmit = (submitData) => {
    const { name, email, phone } = submitData;
    let submittedData;
    let newitems = data;
    newitems.forEach((item) => {
      if (item.id === editId) {
        submittedData = {
          id: item.id,
          avatarBg: item.avatarBg,
          name: name,
          image: item.image,
          role: item.role,
          email: email,
          balance: formData.balance,
          phone: "+" + phone,
          emailStatus: item.emailStatus,
          kycStatus: item.kycStatus,
          lastLogin: item.lastLogin,
          status: formData.status,
          country: item.country,
        };
      }
    });
    let index = newitems.findIndex((item) => item.id === editId);
    newitems[index] = submittedData;
    setModal({ edit: false });
    resetForm();
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    data.forEach((item) => {
      if (item.id === id) {
        setFormData({
          name: item.name,
          email: item.email,
          status: item.status,
          phone: item.phone,
          balance: item.balance,
        });
        setModal({ edit: true }, { add: false });
        setEditedId(id);
      }
    });

  };

  // function to change to suspend property for an item
  const suspendUser = (id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].status = "Suspend";
    setData([...newData]);
  };

  // function to change the check property of an item
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.checked = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // function to delete the seletected item
  const selectorDeleteUser = () => {
    let newData;
    newData = data.filter((item) => item.checked !== true);
    setData([...newData]);
  };

  // function to change the complete property of an item
  const selectorSuspendUser = () => {
    let newData;
    newData = data.map((item) => {
      if (item.checked === true) item.status = "Suspend";
      return item;
    });
    setData([...newData]);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = async (pageNumber) => {
    setLoader(true);
    let data = {
      PageNo: pageNumber,
      PageSize: itemPerPage,
    }
    let res = await Api.GetTenantPagination(data);
    if (res?.data?.statusCode === 200) {
      let datas = (res?.data?.data)?.filter(ele => ele?.isActive);
      const startIndex = (pageNumber - 1) * itemPerPage;
      const endIndex = startIndex + itemPerPage;
      setTotalItems(datas?.length);
      setCurrentPage(pageNumber);
      setTenant(datas.slice(startIndex, endIndex))
    } else {
      setTenant([]);
      setTotalItems(0);
      setCurrentPage(1);
    }
    setLoader(false);
  };


  const { errors, register, handleSubmit } = useForm();
  ///////////123
  const selectStatus = (event) => {

    setStatus(event.target.value);
  };
  const searchUser = (event) => {

    setSearchUserName(event.target.value);
  }
  const searchUserList = async () => {
    if (searchUserNameState?.trim() === "") {
      // await callGetTenant();
      await paginate(1);
    } else {
      let values = {
        TenantId: GetTenantIdUp(),
        PageSize: itemPerPage,
        pageNo: 1,
        NameSearch: searchUserNameState,
        IsPaging: true,
      }
      const userData2 = await Api.GetTenantFilter(values);
      if (userData2?.statusCode === 200) {
        let datas = (userData2?.data)?.filter(ele => ele?.isActive === true);
        const startIndex = 0;
        const endIndex = startIndex + itemPerPage;
        setTotalItems(datas?.length);
        setCurrentPage(1);
        setTenant(datas.slice(startIndex, endIndex))
      } else {
        setTenant([]);
        setTotalItems(0);
        setCurrentPage(1);
      }
    }
  }

  const setInactiveCall = async (data) => {
    try {
      let response = await Api?.SetTenantInactive(data);
      if (response?.data?.statusCode !== 200) {
        Swal?.fire({
          icon: "error",
          title: "Something Went Wrong"
        });
      }
      // callGetTenant();
      await paginate(1);
    } catch (error) {
      Swal?.fire({
        icon: "error",
        title: "Something Went Wrong"
      });
    }
  }

  const handleInAciveUser = async (eve, item) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "Do You want to InActive Tenant?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#7143d9",
      confirmButtonClass: "manageTenatBtn",
    }).then((result) => {
      if (result.isConfirmed) {
        let data = {
          id: item?.tenantId,
          admin: formDataUsername(),
        }
        setInactiveCall(data);
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    });
  }

  const handleHistoryLog = async (eve) => {
    eve?.preventDefault();
    let startDate = new Date(selectedRange[0]?.startDate);
    let endDate = new Date(selectedRange[0]?.endDate);
    startDate = formatDates(startDate)
    endDate = formatDates(endDate)
    handleCloseButtonClick();

    try {
      let data = {
        startDate: startDate,
        endDate: endDate,
        id: historyTenant?.tenantId,
      };
      let response = await Api?.GetAdminHistoryLogDetails(data);
      if (response?.data?.statusCode === 200) {
        let datas = (response?.data?.data)?.map(ele => {
          ele.changeValues = JSON?.parse(ele?.changeValues)
          return ele
        });
        setHistoryList(datas);
      }
    } catch (error) {
    }
  }

  const handleHistoryUser = (eve, item) => {
    setModal({ ...modal, ManageTenant: true });
    setHistoryTenant(item);
  }

  useEffect(async () => {
    // await callGetTenant();
    await paginate(1);
  }, []);
  return (
    <React.Fragment>
      <Head title="User List - Default"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page> Manage Tenant</BlockTitle>
              <BlockDes className="text-soft"> Tenant . Manage Tenant</BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <Row>
              <Col lg="4">
                <div className="form-group">
                  <div className="form-control-wrap">
                    <input onChange={searchUser} className="form-control bg-blue-dim" type="text" id="full-name" placeholder="Search by First Name Or Last Name" />
                  </div>
                </div>
              </Col>
              {/* <Col md="2">
                <div className="form-group">
                  <div className="form-control-wrap">
                    <div className="form-control-select">
                      <select
                        className="form-control form-select focus"
                        id="fv-topics"
                        name="topics"
                        placeholder="Select a option"
                        onChange={selectStatus}
                      >
                        <option label="Active" value={true}></option>
                        <option value={false}>InActive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </Col> */}
              <Col lg="8" className={"responsive_pt"}>
                <div className="justify-end">
                  <Button onClick={searchUserList} className="me-3 applyBtn">Apply</Button>
                  <Button color="primary">
                    <Icon name="plus" />
                    <Link to={`${process.env.PUBLIC_URL}/Tenant/Accounts/AddTenant`}>
                      <span style={{ color: "white" }}>Add</span>
                    </Link>
                  </Button>
                </div>
              </Col>
            </Row>
          </PreviewAltCard>
        </Block>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text text-dark fw-bold">Int Uniqueld</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text text-dark fw-bold">First Name</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text text-dark fw-bold">Last Name</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text text-dark fw-bold">Organization Name</span>
              </DataTableRow>

              <DataTableRow size="xl">
                <span className="sub-text text-dark fw-bold">Email</span>
              </DataTableRow>
              <DataTableRow size="xl">
                <span className="sub-text text-dark fw-bold">Phonenumber</span>
              </DataTableRow>
              <DataTableRow size="xl">
                <span className="sub-text text-dark fw-bold">Status</span>
              </DataTableRow>
              <DataTableRow className="nk-tb-col-tools">
                <span className="sub-text text-dark fw-bold">Action</span>
              </DataTableRow>
            </DataTableHead>
            {/*Head*/}
            {tenantDataState
              ? tenantDataState.map((item, ind) => (
                <DataTableItem key={ind} className={"nk_tb_col_pad"}>
                  <DataTableRow>
                    <span className="nk_tb_col_pad">{item.tenantId}</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="nk_tb_col_pad">
                      {(item.firstName !== null && item.firstName !== "null") && item.firstName}
                    </span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span className="nk_tb_col_pad">
                      {(item.lastName !== null && item.lastName !== "null") && item.lastName}
                    </span>
                  </DataTableRow>
                  <DataTableRow size="sm">
                    <span className="nk_tb_col_pad">{item.organizationName}</span>
                  </DataTableRow>

                  <DataTableRow size="xl">
                    <span className="nk_tb_col_pad">{item.emailId}</span>
                  </DataTableRow>
                  <DataTableRow size="xl">
                    <span className="nk_tb_col_pad">{(item.phoneNo !== "null" && item.phoneNo !== "") ? (item.phoneNo)?.replace("+1", "") : ""}</span>
                  </DataTableRow>
                  <DataTableRow size="xl">
                    <span
                      className={`tb-status nk_tb_col_pad text-${item.isActive ? "success" : "danger"}`}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <ul className="nk-tb-actions justify-content-start">
                      {/* <li className="ps-0">
                        <Link to={`${process.env.PUBLIC_URL}/Tenant/Accounts/TenantConfiguration/${item.tenantId}`}>
                          <TooltipComponent
                            tag="a"
                            containerClassName="btn btn-trigger btn-icon"
                            id={"Configuration" + item.tenantId}
                            icon="file-text"
                            direction="top"
                            text="Tenant Configuration"
                          />
                        </Link>
                      </li> */}
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                            <Icon name="more-h"></Icon>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <ul className="link-list-opt no-bdr">
                              <li onClick={() => onEditClick(item.tenantId)} >
                                <Link to={`${process.env.PUBLIC_URL}/Tenant/Accounts/EditTenant/${item.tenantId}`}>
                                  <Icon name="edit"></Icon>
                                  <span>Edit</span>
                                </Link>
                              </li>
                              <li onClick={eve => handleInAciveUser(eve, item)}>
                                <Link to="#" >
                                  <Icon name="user"></Icon>
                                  <span>In Active</span>
                                </Link>
                              </li>
                              <li onClick={eve => handleHistoryUser(eve, item)}>
                                <Link to="#" >
                                  <Icon name="clock"></Icon>
                                  <span>History</span>
                                </Link>
                              </li>
                              <li onClick={eve => handleHistoryUser(eve, item)}>
                                <Link to={`${process.env.PUBLIC_URL}/Tenant/Accounts/TenantConfiguration/${item.tenantId}`} >
                                  <Icon name="file-text"></Icon>
                                  <span>Tenant Configuration</span>
                                </Link>
                              </li>
                      
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </DataTableRow>
                </DataTableItem>
              ))
              : null}
          </div>
          <PreviewAltCard>
            {(tenantDataState?.length && !loader) > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              !loader ? <div className="d-flex justify-content-center">
                No Data Found.
              </div> : ""
            )}
            {loader && <div className="d-flex justify-content-center">
              <Loaders />
            </div>
            }
          </PreviewAltCard>
        </Block>
      </Content>

      <Modal isOpen={modal.ManageTenant} toggle={() => setModal({ ManageTenant: false })} className="modal-dialog-centered" size="lg">
        <ModalHeader
          close={
            <button className="close" href="#close"
              onClick={(ev) => {
                ev.preventDefault();
                setModal({ ManageTenant: false })
              }}>
              <Icon name="cross" />
            </button>
          }
        >
          History Log
        </ModalHeader>
        <ModalBody>
          <form onSubmit={eve => handleHistoryLog(eve)} autoComplete="off">
            <Row className="mb-3">
              <Col md="12">
                <div className="form-group">
                  <label className="form-label">History Date</label>
                  <input
                    type="text"
                    value={formattedDate()}
                    onClick={handleInputClick}
                    readOnly
                    className="form-control bg-blue-dim"
                  />
                  {showPicker && (
                    <div className="position-relative dateSection">
                      <DateRangePicker
                        ranges={selectedRange}
                        onChange={handleDateRange}
                      />
                      <Icon name={"cross"} onClick={handleCloseButtonClick} style={{ cursor: "pointer" }} className={"datePickerCloseBtn position-absolute fs-2 "}> </Icon>
                    </div>
                  )}
                </div>
              </Col>
            </Row>



            <div className="justify-end">
              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                <li>
                  <Button color="primary" size="md" type="submit">
                    Save
                  </Button>
                </li>
                <li>
                  <a
                    href="#cancel"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onFormCancel();
                    }}
                    className="link link-light"
                  >
                    Cancel
                  </a>
                </li>
              </ul>
            </div>
          </form>
          {historylist?.length > 0 && <div className="history_sec mt-4">
            {historylist?.map((ele, ind) => {
              return <div className="" key={ind}>
                {ele?.changeValues?.map((elem, indd) => {
                  return <div><div className={`d-flex pb-2 `} key={indd}>
                    <div className="history_logo d-flex align-items-center justify-content-center fw-bold fs-4">
                      {elem?.UserName?.[0]}
                    </div>
                    <div className="ps-2">
                      <p className="fs-6"><span className="fw-bold">{elem?.UserName}</span>  has Updated <span className="fw-bold">{elem?.DisplayFieldName}</span> at
                        {elem?.UpdatedDate}</p>
                      <div class="d-flex align-items-center ">
                        <span class="badge badge-light-danger text-danger rounded fs-6"> {elem?.Previous} </span>
                        <span><Icon name="arrow-right"></Icon></span>
                        <span class="badge badge-light-success rounded-pill fs-6"> {elem?.Current}</span>
                      </div>
                    </div>
                  </div>

                  </div>
                })}

              </div>
            })}
          </div>}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
export default ManageTenant;
